
export const environmentServed = {
	flags: { },
	paths: {
		models: '/Client/docs/models/',
	},
	assets: '/Client/docs/',
	worker: '/Client/docs/js/workers/image.service.worker.js',
};
